import { IBannerResponse } from '../../../../model/apm/banner/response/banner-response';

export type BannerState = {
    banners: IBannerResponse[];
    loading: boolean;
    drawer: { open: boolean; banner?: IBannerResponse };
};

export enum ACTION_TYPES {
    setBanners = 'setBanners',
    setLoading = 'setLoading',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const BannerReducer = (state: BannerState, action: any): BannerState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setBanners:
            return { ...state, banners: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, banner: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
